import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { FormattedMessage } from 'react-intl';
import { useSplitShipModalContext } from './split-ship-modal-context-provider';
import headerStyle from './items-table-header.module.less';
import { ascending } from '../../constants/sortDirections';
import { columnDefinitions } from './items-table-column-definitions';

const ItemsTableHeader = () => {
  const { sort, sortState } = useSplitShipModalContext();

  return (
    <thead>
      <tr className={headerStyle['header-row']}>
        {columnDefinitions.map(({ columnId, headerClassName, message, isSortable }) => {
          const clickHandler = isSortable ? () => sort(columnId) : undefined;
          const isSorted = columnId === sortState.column;
          const iconClassName = isSorted ? headerStyle['sorted-sort-icon'] : headerStyle['sort-icon'];
          const icon = isSorted && sortState.direction === ascending ? faCaretUp : faCaretDown;

          return (
            <th key={columnId} className={headerClassName} onClick={clickHandler}>
              <div className={headerStyle['header-cell-content']}>
                {message && <FormattedMessage {...message} />}
                {isSortable && <FontAwesomeIcon className={iconClassName} icon={icon} />}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export { ItemsTableHeader };
